import { render, staticRenderFns } from "./JournalDialog.vue?vue&type=template&id=02794b3f"
import script from "./JournalDialog.vue?vue&type=script&lang=js"
export * from "./JournalDialog.vue?vue&type=script&lang=js"
import style0 from "./JournalDialog.vue?vue&type=style&index=0&id=02794b3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports